import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div<{ $diseable: boolean }>`
	width: 100%;
	min-width: 0;
	position: relative;
	opacity: ${(props) => (props.$diseable ? '0.5' : '1')};
`;

export const inputTextArea = styled.div<{
	$borderColor: string;
	$labelColor: string;
}>`
	width: 100%;
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 0.5rem;

	> p {
		min-width: 0;
		font-weight: 700;
		color: ${(props) => props.$labelColor};
		font-size: 1.4rem;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	> textarea {
		all: unset;
		width: 100%;
		min-width: 0;
		border: 1px solid ${(props) => props.$borderColor};
		padding-top: 1rem;
		padding-bottom: 1rem;
		font-family: nunito-regular;
		color: ${color.interface.lightGray};
		font-size: 1.5rem;
		padding-inline-start: 10px;
		box-sizing: border-box;
		border-radius: 5px;
		word-break: break-all;
	}

	> span {
		font-size: 1.3rem;
		color: ${color.system.info};
	}
`;

export const maxLetters = styled.p`
	width: 100%;
	text-align: right;
	font-size: 1.3rem;
	font-weight: 900;
	color: ${color.interface.lightGray};
`;

export const errorMessage = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	> p {
		color: ${color.interface.red};
		font-size: 1.2rem;
	}
`;

export const diseableDiv = styled.div`
	position: absolute;
	top: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(235, 231, 231, 0.1);
	z-index: 10;
	cursor: not-allowed;
`;
